import React from "react";

import { wrap } from "./RydTestbedWrap";
import {
    Note,
    Tone
} from "../model/core";
import {
    IntervalPattern,
    ScalePattern,
    Tonality,
} from "../model/scales";
import {
    isToneCenter,
    RydScaleInfobox
} from "../components/inspector/RydScaleInfobox";
import { RydScaleSelector } from "../components/widgets/RydScaleSelector";
import { PianoRollKeybed } from "../components/rolls/PianoKeybed";


function EurydiceScaleSelectorTestbed() {

    const [root, setRoot] = React.useState<Tone>();
    const [intervalPattern, setIntervalPattern] = React.useState<IntervalPattern>();
    const [tonality, setTonality] = React.useState<Tonality>();

    React.useEffect(() => {
        console.log('Root changed: ', root, 'IntervalPattern: ', intervalPattern);
        if (root && intervalPattern) {
            const t = new Tonality(root, new ScalePattern(intervalPattern));
            setTonality(t);
        }
    }, [root, intervalPattern]);

    const rootSelected = (n: Note) => setRoot(n.getTone());
    const patternSelected = (p: IntervalPattern) => setIntervalPattern(p);

    return wrap(<>
        <h2>Scale selector testbed</h2>
        <table>
            <tbody>
                <tr>
                    <td>Active steps</td>
                    <td>
                        <RydScaleSelector patternChangedCB={patternSelected} />
                    </td>
                    <td>State: {intervalPattern?.name}</td>
                </tr>
                <tr>
                    <td>Root note</td>
                    <td>
                        <PianoRollKeybed noteRange={{ min: 24, max: 24 + 12 }}
                            triggerCB={rootSelected}
                            stylingSource={(n) => isToneCenter(n, root)}
                            orientation="keyboard"
                        />

                    </td>
                    <td>State: {root?.getName()}</td>
                </tr>
                <tr>
                    <td>Resulting</td>
                    <td>
                        {tonality && <RydScaleInfobox tonality={tonality} />}
                    </td>
                </tr>
            </tbody>
        </table>
    </>);
}

export {
    EurydiceScaleSelectorTestbed
};